import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class EstadoRecorridoService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  GetByEstadoRecorrido(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query{
          estado_recorrido {
            obtenerTodos {
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                }
              }
            }
          }
        }
        `,
        variables: {},
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.estado_recorrido.obtenerTodos
        callback({ mensajes, respuesta })
      }
    );
  }

  GetByEstadoRecorridoLisquidacion(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query{
          estado_recorrido {
            obtenerEstadoLiquidacion {
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                }
              }
            }
          }
        }
        `,
        variables: {},
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.estado_recorrido.obtenerEstadoLiquidacion
        callback({ mensajes, respuesta })
      }
    );
  }
}
